define('imovel-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('imovel.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Imovel', ['$q', '$http', '$location', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, i18n, appRoute, notify, $multipart) {
      return {
        getFiltros:function () {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('imovel.getFiltros')).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },
        getCidade:function (est_codigo, cid_nome) {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('imovel.getCidade', {'est_codigo':est_codigo, 'cid_nome':cid_nome})).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },
        getBairro:function (cid_codigo, imo_bairro) {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('imovel.getBairro', {'cid_codigo':cid_codigo, 'imo_bairro':imo_bairro})).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },
        getLotes:function (condominio) {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('imovel.getLotes', {'imocon_codigo':condominio})).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },
        getQuadras:function (condominio, lote) {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('imovel.getQuadras', {'imocon_codigo':condominio, 'imo_lote':lote})).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },
        getEmpreendimento:function (text) {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('imovel.getEmpreendimento', {imoc_nome:text})).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },
        getImovel:function (filtro) {//index de amostra
          return $q(function (resolve, reject) {
            notify.clearNotifications();
            $http.post(appRoute.linkTo('imovel.getImovel'), filtro).success(function (data) {
              //if (data && data.notifications && !_.isEmpty(data.notifications)) {
              //  notify.addNotification(data.notifications);
              //}
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });

          });
        },
        getImovelFiltro:function (filtro) {//index de amostra
          return $q(function (resolve, reject) {
            notify.clearNotifications();
            $http.get(appRoute.linkTo('imovel.getImovelFiltro', {imo_codigo: filtro})).success(function (data) {

              //if (data && data.notifications && !_.isEmpty(data.notifications)) {
              //  notify.addNotification(data.notifications);
              //}
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });

          });
        },
        getDetalhe: function(token){
          return $q(function (resolve, reject) {
            $http.get($location.absUrl()+'/'+token).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });

        },
        getThumbViemo: function(id){
          return $q(function(resolve, reject){
            $http.get('http://vimeo.com/api/v2/video/' + id + '.json?callback=JSON_CALLBACK').success(function (data) {
                return data;
            });
          });
        },
        enviaContatoImovel: function(obj){
        return $http.post(appRoute.linkTo('contato.enviaContatoImovel'), obj);
      },

        saveSolicitacao:function(data){
          return $http.post(appRoute.linkTo('imovel.saveSolicitacao'), data);
        },


        getChaves:function(data){
          return $http.post(appRoute.linkTo('imovel.getChaves'), data);
        },

        enviaContatoIndique: function(obj){
          return $http.post(appRoute.linkTo('contato.enviaContatoIndique'), obj);
        },
        enviaContatoCorretor: function(obj){
          return $http.post(appRoute.linkTo('contato.enviaContatoCorretor'), obj);
        },
        listTemporada:function(data) {
          return $http.post(appRoute.linkTo('imovel.listTemporada'), data);
        },
        saveIndisponibilidadeTmp:function(data){
          return $http.post(appRoute.linkTo('imovel.saveIndisponibilidadeTmp'), data);
        },
        saveForm:function(data){
          return $http.post(appRoute.linkTo('imovel.saveForm'), data);
        },
        getGeminidas:function(data){
          return $http.post(appRoute.linkTo('imovel.getGeminidas'), data);
        },
        enviaClassificados:function(obj){
            return $http.post(appRoute.linkTo('imovel.enviaClassificados'), obj);
        },

        getSolicitacoesChave:function(data){
          return $http.post(appRoute.linkTo('imovel.getSolicitacoesChave'), data);
        },
        cancelarSolicitacaoChave:function(data){
          return $http.post(appRoute.linkTo('imovel.cancelarSolicitacaoChave'), data);
        },
        getRestInfo:function(imo_codigo){
          return $q(function (resolve, reject) {
           $http.post(appRoute.linkTo('imovel.getRestInfo'), {imo_codigo:imo_codigo}).success(function (data) {
            resolve(data);
           }).error(function (error) {
            reject(error);
          });
         });
        }
      }
    }]);
});

